/* ═══════════════════════════════════════
   AirLog Formatters
   Date, time, and display formatting
   ═══════════════════════════════════════ */

   export const formatTimestamp = (ts) => {
    const d = new Date(ts)
    const mins = Math.floor((new Date() - d) / 60000)
    if (mins < 1) return 'Just now'
    if (mins < 60) return `${mins}m ago`
    if (mins < 1440) return `${Math.floor(mins / 60)}h ago`
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  }
  
  export const formatEventTime = (s) => {
    return new Date(s).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })
  }
  
  export const formatRecordingTime = (s) => {
    return `${Math.floor(s / 60).toString().padStart(2, '0')}:${(s % 60).toString().padStart(2, '0')}`
  }